import Head from "next/head";
import BreadcrumbScrollCX from "../../../components/Elements/BreadcrumbScrollCX/BreadcrumbScrollCX";
import cx from "classnames";
import styles from "../../../styles/CXpages.module.css";
import ogCX from "../../../images/ogCX.png";
import { useRef, useState } from "react";
import { useScroll, motion, calcLength } from "framer-motion";
import { useDetectScroll } from "@smakss/react-scroll-direction";
import cxVline from "../../../images/cxVline.svg";
import useIntersection from "../../../components/Services/useIntersection";
import Image from "next/image";
import circle from "../../../images/circle.svg";
import linkShare from "../../../images/linkShare.svg";
import emailShare from "../../../images/emailShare.svg";
import telegramShare from "../../../images/telegramShare.svg";
import whatsappShare from "../../../images/whatsappShare.svg";
import iPhoneFrame from "../../../images/iPhoneFrame.svg";

import { useRouter } from "next/router";
import Snackbar from "@mui/material/Snackbar";
import like from "../../../images/like.svg";
import dislike from "../../../images/dislike.svg";
import sentimentChartDesktop from "../../../images/sentimentChartDesktop.svg";
import sentimentChartMobile from "../../../images/sentimentChartMobile.svg";
import Link from "next/link";
import qualityPieMobile from "../../../images/qualityPieMobile.svg";
import qualityPieDesktop from "../../../images/qualityPieDesktop.svg";
import qualityTweet from "../../../images/qualityTweet.svg";
import qualityOriginal from "../../../images/qualityOriginal.svg";
import cx4stars from "../../../images/cx4stars.svg";
import qual2 from "../../../images/qual2.svg";
import qual3 from "../../../images/qual3.svg";
import qual4 from "../../../images/qual4.svg";
import qual5 from "../../../images/qual5.svg";
import qual11 from "../../../images/qual11.svg";
import qual12 from "../../../images/qual12.svg";
import qual13 from "../../../images/qual13.svg";
import qual14 from "../../../images/qual14.svg";
import cxAssortments from "../../../images/cxAssortments.svg";
import psatVerticals from "../../../images/psatVerticals.svg";

import psatTypes from "../../../images/psatTypes.png";
import cxPSAT from "../../../video/cxPSAT.mp4";
import cxReturn from "../../../video/cxReturn.mp4";
// import cxCommentSentiment from "../../../images/cxCommentSentiment.png"

// import cxArrow from "../../../images/cxArrow.svg"
import BrandsModal from "./BrandsModal";
import FakeModal from "./FakeModal";
import DamagedModal from "./DamagedModal";

const Index = () => {
  const router = useRouter();

  const pageDetails = {
    pageTitle: "درباره کیفیت کالا",
    pagePath: `https://about.digikala.com${router.asPath}`,
    pageDesc:
      "پایین بودن کیفیت کالا نه برای شما به عنوان مشتری خوشایند است نه برای ما که می‌کوشیم نرخ بازگشت کالا به دلیل کیفیت را کاهش دهیم. در این بخش، درباره کیفیت کالا در دیجی‌کالا بخوانید.",
  };

  // toast handler after link copy
  const [openToast, setOpenToast] = useState(false);
  const onShareHandler = () => {
    navigator.clipboard.writeText(pageDetails.pagePath);
    openToastHandler();
  };
  const openToastHandler = () => {
    setOpenToast(true);
  };
  const closeToastHandler = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenToast(false);
  };
  // end of toast handler after link copy

  const ref1 = useRef();
  const ref2 = useRef();
  const ref3 = useRef();
  const ref4 = useRef();
  const ref5 = useRef();
  const ref6 = useRef();
  const ref7 = useRef();
  const ref8 = useRef();

  const refReturn = useRef();
  const refFake = useRef();
  const refSat1 = useRef();
  const refSat2 = useRef();

  const { scrollYProgress: scroll1 } = useScroll({
    target: ref1,
    offset: ["start end", "end end"],
  });
  const { scrollYProgress: scroll2 } = useScroll({
    target: ref2,
    offset: ["start end", "end end"],
  });
  const { scrollYProgress: scroll3 } = useScroll({
    target: ref3,
    offset: ["start end", "end end"],
  });
  const { scrollYProgress: scroll4 } = useScroll({
    target: ref4,
    offset: ["start end", "end end"],
  });
  const { scrollYProgress: scroll5 } = useScroll({
    target: ref5,
    offset: ["start end", "end end"],
  });
  const { scrollYProgress: scroll6 } = useScroll({
    target: ref6,
    offset: ["start end", "end end"],
  });
  const { scrollYProgress: scroll7 } = useScroll({
    target: ref7,
    offset: ["start end", "end end"],
  });
  // const { scrollYProgress: scroll8 } = useScroll({
  //     target: ref8,
  //     offset: ["start end" , "end end"]
  // })

  const { scrollYProgress: scrollAll } = useScroll({
    offset: ["start end", "end end"],
  });

  const { scrollYProgress: scrollRefReturn } = useScroll({
    target: refReturn,
    offset: ["start end", "end end"],
  });
  const { scrollYProgress: scrollRefFake } = useScroll({
    target: refFake,
    offset: ["start end", "end end"],
  });
  const { scrollYProgress: scrollRefSat1 } = useScroll({
    target: refSat1,
    offset: ["start end", "end end"],
  });
  const { scrollYProgress: scrollRefSat2 } = useScroll({
    target: refSat2,
    offset: ["start end", "end end"],
  });

  const spring = {
    type: "spring",
    damping: 10,
    stiffness: 1,
  };

  const [scrollDir] = useDetectScroll({});

  const ref1inViewport = useIntersection(ref1, "0px");
  const ref2inViewport = useIntersection(ref2, "0px");
  const ref3inViewport = useIntersection(ref3, "0px");
  const ref4inViewport = useIntersection(ref4, "0px");
  const ref5inViewport = useIntersection(ref5, "0px");
  const ref6inViewport = useIntersection(ref6, "0px");
  const ref7inViewport = useIntersection(ref7, "0px");
  // const ref8inViewport = useIntersection(ref8, '0px');

  return (
    <>
      <Head>
        <title>{pageDetails.pageTitle}</title>
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
        <meta charSet="utf-8" />
        <meta name="description" content={pageDetails.pageDesc} />
        <link rel="icon" type="image/x-icon" href="/faviconNew.svg"></link>
        <meta
          name="robots"
          content="index, follow, max-snippet:-1, max-video-preview:-1, max-image-preview:large"
        />
        <meta property="og:locale" content="fa_IR" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={pageDetails.pageTitle} />
        <meta property="og:url" content={pageDetails.pagePath} />
        <meta property="og:site_name" content="درباره گروه دیجی‌کالا" />
        <meta property="og:image" itemProp="image" content="/ogCX.png" />
        <meta property="og:image:width" content="665" />
        <meta property="og:image:height" content="370" />
        <meta property="og:image:alt" content={pageDetails.pageTitle} />
        <meta property="og:image:type" content="image/png" />
        <meta
          property="og:site_name"
          content="درباره گروه دیجی‌کالا"
          key="ogsitename"
        />
        <meta
          property="og:title"
          content={pageDetails.pageTitle}
          key="ogtitle"
        />
        <meta
          property="og:description"
          content={pageDetails.pageDesc}
          key="ogdesc"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={pageDetails.pageTitle} />
        <meta name="twitter:site" content="درباره گروه دیجی‌کالا" />
        <meta
          name="twitter:image"
          content="https://about.digikala.com/ogCX.png"
        />
        <meta name="twitter:description" content={pageDetails.pageDesc} />
      </Head>

      <Snackbar
        open={openToast}
        autoHideDuration={2000}
        onClose={closeToastHandler}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        message={
          <div className="w-100 d-flex align-items-center justify-content-between">
            <span className={cx(styles.toasTextStyles, "d-flex", "w-100")}>
              لینک مطلب کپی شد!
            </span>
          </div>
        }
      />

      <BreadcrumbScrollCX
        title="کیفیت کالا"
        routeOne="/customer-experience/"
        titleOne="درباره تجربه مشتریان"
        routeTwo="/customer-experience/product-quality/"
        titleTow="کیفیت کالا"
      />

      <div className={cx(styles.mainPage)}>
        <div
          className={cx(
            styles.progressBarMain,
            scrollDir !== "down" ? styles.Stick : styles.notStick
          )}
        >
          <motion.div
            className={cx(styles.progressBarInner)}
            style={{ scaleX: scroll1 }}
            transition={spring}
          />
          <motion.div
            className={cx(styles.progressBarInner)}
            style={{ scaleX: scroll2 }}
            transition={spring}
          />
          <motion.div
            className={cx(styles.progressBarInner)}
            style={{ scaleX: scroll3 }}
            transition={spring}
          />
          <motion.div
            className={cx(styles.progressBarInner)}
            style={{ scaleX: scroll4 }}
            transition={spring}
          />
          <motion.div
            className={cx(styles.progressBarInner)}
            style={{ scaleX: scroll5 }}
            transition={spring}
          />
          <motion.div
            className={cx(styles.progressBarInner)}
            style={{ scaleX: scroll6 }}
            transition={spring}
          />
          <motion.div
            className={cx(styles.progressBarInner)}
            style={{ scaleX: scroll7 }}
            transition={spring}
          />
          {/* <motion.div
                className={cx(styles.progressBarInner)}
                style={{ scaleX: scroll8 }}
                transition={spring}
                /> */}

          {/* On Mobile  */}
          <motion.div
            className={cx(styles.progressBarInnerMobile)}
            style={{ scaleX: scrollAll }}
            transition={spring}
          />
        </div>

        <div
          className={cx(
            styles.progressBarMainTitles,
            scrollDir !== "down" ? styles.Stick : styles.notStick
          )}
        >
          <div
            className={cx(
              styles.progressBarInnerTitle,
              ref1inViewport
                ? ref2inViewport
                  ? styles.mobileShrinkable
                  : ""
                : styles.mobileShrinkable
            )}
            onClick={() =>
              ref1?.current?.scrollIntoView({
                behavior: "smooth",
                block: "start",
              })
            }
          ></div>
          <div
            className={cx(styles.progressBarInnerVline, "d-none d-md-block")}
          ></div>
          <div
            className={cx(
              styles.progressBarInnerTitle,
              ref2inViewport
                ? ref3inViewport
                  ? styles.mobileShrinkable
                  : ""
                : styles.mobileShrinkable
            )}
            onClick={() =>
              ref2?.current?.scrollIntoView({
                behavior: "smooth",
                block: "start",
              })
            }
          >
            <h5>غیر اصل بودن</h5>
          </div>
          <div
            className={cx(styles.progressBarInnerVline, "d-none d-md-block")}
          ></div>
          <div
            className={cx(
              styles.progressBarInnerTitle,
              ref3inViewport
                ? ref4inViewport
                  ? styles.mobileShrinkable
                  : ""
                : styles.mobileShrinkable
            )}
            onClick={() =>
              ref3?.current?.scrollIntoView({
                behavior: "smooth",
                block: "start",
              })
            }
          >
            <h5>مغایرت</h5>
          </div>
          <div
            className={cx(styles.progressBarInnerVline, "d-none d-md-block")}
          ></div>
          <div
            className={cx(
              styles.progressBarInnerTitle,
              ref4inViewport
                ? ref5inViewport
                  ? styles.mobileShrinkable
                  : ""
                : styles.mobileShrinkable
            )}
            onClick={() =>
              ref4?.current?.scrollIntoView({
                behavior: "smooth",
                block: "start",
              })
            }
          >
            <h5>آسیب دیدگی</h5>
          </div>
          <div
            className={cx(styles.progressBarInnerVline, "d-none d-md-block")}
          ></div>
          <div
            className={cx(
              styles.progressBarInnerTitle,
              ref5inViewport
                ? ref6inViewport
                  ? styles.mobileShrinkable
                  : ""
                : styles.mobileShrinkable
            )}
            onClick={() =>
              ref5?.current?.scrollIntoView({
                behavior: "smooth",
                block: "start",
              })
            }
          >
            <h5>رضایت از کیفیت</h5>
          </div>
          <div
            className={cx(styles.progressBarInnerVline, "d-none d-md-block")}
          ></div>
          <div
            className={cx(
              styles.progressBarInnerTitle,
              ref6inViewport
                ? ref7inViewport
                  ? styles.mobileShrinkable
                  : ""
                : styles.mobileShrinkable
            )}
            onClick={() =>
              ref6?.current?.scrollIntoView({
                behavior: "smooth",
                block: "start",
              })
            }
          >
            <h5>ترفندهای خرید</h5>
          </div>
          <div
            className={cx(styles.progressBarInnerVline, "d-none d-md-block")}
          ></div>
          <div
            className={cx(
              styles.progressBarInnerTitle,
              ref7inViewport ? "" : styles.mobileShrinkable
            )}
            onClick={() =>
              ref7?.current?.scrollIntoView({
                behavior: "smooth",
                block: "start",
              })
            }
          ></div>
        </div>

        <div className={cx(styles.pageContainer)}>
          <div ref={ref1} className={cx(styles.experience)}>
            <h1 className="py-2">مشتریان دیجی‌کالا و رضایت از کیفیت کالاها</h1>

            <div className={cx(styles.smsBox)}>
              <Image
                src={qualityTweet}
                alt="Tweet about Quality"
                className="px-1 px-md-5"
              />
            </div>

            <p>
              کالایی را از دیجی‌کالا سفارش داده‌اید اما پس از تحویل گرفتن، متوجه
              می‌شوید که با انتظارتان فاصله دارد. اینکه چیزی را که تحویل
              گرفته‌اید مطابق چیزی نباشد که در دیجی‌کالا انتخاب کرده بودید یعنی
              ما نتوانسته‌ایم کالایی مطابق با کیفیت مورد انتظار شما را به دستتان
              برسانیم.
            </p>
            <p>
              پایین بودن کیفیت کالا نه برای شما به عنوان مشتری خوشایند است نه
              برای ما که می‌کوشیم نرخ بازگشت کالا به دلیل کیفیت را کاهش دهیم.
            </p>

            <div ref={refReturn} className={cx(styles.purpleContainer)}>
              <div className="d-inline-block">
                <h3>۴۱٪</h3>
                <motion.hr
                  style={{ scaleX: scrollRefReturn }}
                  transition={spring}
                />
              </div>

              <h6 className="pb-3">
                از کل کالاهای مرجوع شده در ۹ ماهه اول ۱۴۰۱ به دلیل کیفیت کالا
                بوده است.
              </h6>

              <hr className={cx(styles.simpleInpurpleHr)} />
              <p>
                در ۹ ماه اول سال ۱۴۰۱ فقط ۳/۴ درصد از کل کالاهای فروخته شده
                مرجوع شده‌اند.
              </p>
            </div>

            <p>
              کالایی که به دست مشتری می‌رسد در چند حالت ممکن است امتیاز خوبی از
              نظر کیفیت نگیرد:
            </p>

            <Image
              src={qualityPieDesktop}
              alt="Pie Chart about quality"
              className={cx(styles.fullautoImage, "d-none d-md-block my-5")}
            />
            <Image
              src={qualityPieMobile}
              alt="Pie Chart about quality"
              className={cx(styles.fullautoImage, "d-block d-md-none my-5")}
            />

            <p>
              آمارهای مربوط به گزارش‌های مشتریان درباره کیفیت کالاها پس از طی
              کردن فرایند مرجوعی اعتبار سنجی می‌شود. در این مسیر، ابتدا واحد
              خدمات پس از فروش و سپس بخش نظارت بر عملکرد فروشندگان مجدداً
              گزارش‌های واحد خدمات پس از فروش را بر اساس پارامترهای نظارتی خود
              بازبینی می‌کند.
            </p>
          </div>

          <div ref={ref2} className={cx(styles.experience2)}>
            <div className={cx(styles.cxVline)}>
              <Image src={cxVline} alt="Line" />
            </div>
            <div className={cx(styles.cxVlineVl)}></div>

            <div className="d-block w-100">
              <h2>غیر اصل بودن کالا</h2>
              <p>
                دریافت کالای تقلبی یکی از تجربه‌های ناخوشایند برخی مشتریان در
                خرید از دیجی‌کالاست. منظور از کالای غیر اصل، کالایی‌ست که مشابه
                برند اصلی‌ست اما توسط تولیدکننده اصلی تولید نشده است. دیجی‌کالا
                تمام ادعاهای مشتریان درباره غیر اصل بودن کالاها را بررسی می‌کند
                و بر اساس هر کدام از درخواست‌ها به مشتریان سرویس می‌دهد.
              </p>

              {/*<div ref={refFake} className={cx(styles.purpleContainer)}>*/}
              {/*    <div className="d-inline-block">*/}
              {/*        <p>در ۹ ماه اول سال ۱۴۰۱</p>*/}
              {/*        <h3 style={{display:"inline"}}> ۱۵٬۰۰۰+ </h3> <h6 style={{display:"inline"}}>تنوع کالایی</h6>*/}
              {/*        <motion.hr*/}
              {/*            style={{ scaleX: scrollRefFake }}*/}
              {/*            transition={spring}*/}
              {/*            />*/}
              {/*    </div>*/}
              {/*    */}
              {/*    <h6 className="pb-3">*/}
              {/*        به عنوان کالای تقلبی شناسایی شده است.*/}
              {/*    </h6>*/}
              {/*    */}
              {/*</div>*/}

              <p>
                یکی از راه‌های ما برای شناسایی کالای تقلبی از اصل، دریافت
                بازخوردهای شما در زمان مرجوعی کالاهاست. در میان علل مرجوعی هر
                کالا با انتخاب یک گزینه می‌توانید این تجربه را اطلاع دهید:
              </p>
              <div>
                <Image
                  src={qualityOriginal}
                  alt="original icon"
                  className={cx(styles.inlineIcon, "me-3")}
                />{" "}
                کالای غیر اصل دریافت کرده‌ام.
              </div>
              <div className={cx(styles.greenContainer)}>
                <h3>
                  کالاهایی که غیر اصل بودن آنها پس از گزارش کاربران و بررسی بخش
                  خدمات پس از فروش و واحد نظارت در بخش بازرگانی محرز می‌شود تا
                  ۹۰ روز قابلیت مرجوعی دارند.
                </h3>
              </div>

              {/*<div className={cx(styles.blueContainer)}>*/}
              {/*    <div className="row m-0 p-0 w-100">*/}
              {/*        <div className="col-12 col-md-9 mb-3 mb-md-auto">*/}
              {/*            <span className={cx(styles.blueContainerTitle)}>تاثیر خروج برندهای معتبر از بازار ایران بر عرضه کالای با کیفیت در دیجی‌کالا</span>*/}
              {/*        </div>*/}
              {/*        <div className="col-12 col-md-3 d-flex justify-content-end">*/}
              {/*             <span className={cx(styles.blueContainerBtn)}>*/}
              {/*                <BrandsModal />*/}
              {/*            </span>*/}
              {/*        </div>*/}
              {/*    </div>*/}
              {/*</div>*/}
            </div>
          </div>

          <div ref={ref3} className={cx(styles.experience2)}>
            <div className={cx(styles.cxVline)}>
              <Image src={cxVline} alt="Line" />
            </div>
            <div className={cx(styles.cxVlineVl)}></div>

            <div className="d-block w-100">
              <h2>مغایرت کالا</h2>
              <p>
                تحویل گرفتن کالای دیگری به غیر از کالای مطلوب یا کالایی که با
                اطلاعات و مشخصات درج شده در زمان خرید متفاوت است تجربه
                ناخوشایندی‌ست که مشتری را نسبت به کیفیت کالاها نا امید می‌کند.
                مغایرت زمانی رخ می‌دهد که مشخصات کالایی که به دست شما رسیده است
                با اطلاعات درج شده در دیجی‌کالا تفاوت داشته باشد.
              </p>
              <p>
                یکی از پرسش‌هایی که در نظرسنجی میزان رضایت مشتریان (CSAT) پس از
                خرید سؤال می‌شود مربوط به مفید بودن عکس‌ها و اطلاعات کالاست که
                به موضوع تطابق کالای سفارش داده شده و کالای دریافتی مرتبط است.
              </p>

              <div ref={refSat1} className={cx(styles.purpleContainer)}>
                <div className="d-inline-block">
                  <p>در ۹ ماه اول سال ۱۴۰۱</p>
                  <Image
                    className={cx(styles.inlineStars)}
                    src={cx4stars}
                    alt="Tweet about Quality"
                  />{" "}
                  <h3 style={{ display: "inline" }}> امتیاز ۴/۲ از ۵ </h3>
                  <motion.hr
                    style={{ scaleX: scrollRefSat1 }}
                    transition={spring}
                  />
                </div>

                <h6 className="pb-3">
                  میانگین امتیاز رضایت مشتریان از مفید بودن عکس‌ها و اطلاعات
                </h6>
              </div>

              <p>
                در میان علل مرجوعی هر کالا چند گزینه (بسته به نوع کالا) وجود
                دارد که با انتخاب آنها به ما کمک می‌کنید در جریان تجربه‌تان از
                وضعیت کیفیت کالا از نظر مغایر بودن آن قرار بگیریم:
              </p>

              <div>
                <Image
                  src={qual2}
                  alt="original icon"
                  className={cx(styles.inlineIcon, "me-3")}
                />{" "}
                کالای غیر اصل دریافت کرده‌ام.
              </div>
              <div>
                <Image
                  src={qual3}
                  alt="original icon"
                  className={cx(styles.inlineIcon, "me-3")}
                />{" "}
                رنگ کالای ارسال شده مغایرت دارد.
              </div>
              <div>
                <Image
                  src={qual4}
                  alt="original icon"
                  className={cx(styles.inlineIcon, "me-3")}
                />{" "}
                کالای دیگری ارسال شده است.
              </div>
              <div className="mb-5">
                <Image
                  src={qual5}
                  alt="original icon"
                  className={cx(styles.inlineIcon, "me-3")}
                />{" "}
                سفارش به صورت کامل ارسال نشده است.
              </div>

              {/* <div className={cx(styles.blueContainer)}>
                        <span className={cx(styles.blueContainerTitle)}>راهکارهای دیجی‌کالا برای کاهش عرضه کالاهای مغایر و غیر اصل بدون نشان</span>
                        <span className={cx(styles.blueContainerBtn)}>
                            بیشتر بخوانید
                        </span>
                    </div> */}

              <div className={cx(styles.blueContainer)}>
                <div className="row m-0 p-0 w-100">
                  <div className="col-12 col-md-9 mb-3 mb-md-auto">
                    <span className={cx(styles.blueContainerTitle)}>
                      راهکارهای دیجی‌کالا برای کاهش عرضه کالاهای مغایر و غیر اصل
                      بدون نشان
                    </span>
                  </div>
                  <div className="col-12 col-md-3 d-flex justify-content-end">
                    <span className={cx(styles.blueContainerBtn)}>
                      <FakeModal />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div ref={ref4} className={cx(styles.experience2)}>
            <div className={cx(styles.cxVline)}>
              <Image src={cxVline} alt="Line" />
            </div>
            <div className={cx(styles.cxVlineVl)}></div>

            <div className="d-block w-100">
              <h2>آسیب دیدگی کالا</h2>
              <p>
                یک کالا در صورت داشتن خط و خش و کثیفی یا آسیب دیدگی و شکستگی
                امتیاز پایینی از نظر کیفیت می‌گیرد.
              </p>
              <p>
                در میان علل مرجوعی چند گزینه (بسته به نوع کالا) وجود دارد که با
                انتخاب آنها به ما کمک می‌کنید در جریان تجربه‌تان از وضعیت کیفیت
                کالا یا سفارش از نظر میزان سالم بودن آن قرار بگیریم:
              </p>

              <div>
                <Image
                  src={qual11}
                  alt="original icon"
                  className={cx(styles.inlineIcon, "me-3")}
                />{" "}
                فیزیک کالا آسیب دیده اما بسته بندی کالا سالم است.
              </div>
              <div>
                <Image
                  src={qual12}
                  alt="original icon"
                  className={cx(styles.inlineIcon, "me-3")}
                />{" "}
                کالا ایراد فنی دارد.
              </div>
              <div>
                <Image
                  src={qual13}
                  alt="original icon"
                  className={cx(styles.inlineIcon, "me-3")}
                />{" "}
                کالا خط و خش دارد.
              </div>
              <div>
                <Image
                  src={qual14}
                  alt="original icon"
                  className={cx(styles.inlineIcon, "me-3")}
                />{" "}
                تاریخ انقضای محصول گذشته است.
              </div>

              <div className={cx(styles.purpleContainer)}>
                <div className="d-flex text-center py-3">
                  <h6>
                    با انجام اقدام‌های عملیات دیجی‌کالا، میزان کالاهای آسیب دیده
                    در ۹ ماه اول ۱۴۰۱ تا ۵۰ درصد کاهش یافته است.
                  </h6>
                </div>
              </div>

              {/* <div className={cx(styles.blueContainer)}>
                        <span className={cx(styles.blueContainerTitle)}>راهکارهای دیجی‌کالا برای کاهش عرضه کالاهای آسیب‌دیده</span>
                        <span className={cx(styles.blueContainerBtn)}>
                            بیشتر بخوانید
                        </span>
                    </div> */}

              <div className={cx(styles.blueContainer)}>
                <div className="row m-0 p-0 w-100">
                  <div className="col-12 col-md-9 mb-3 mb-md-auto">
                    <span className={cx(styles.blueContainerTitle)}>
                      راهکارهای دیجی‌کالا برای کاهش عرضه کالاهای آسیب‌دیده
                    </span>
                  </div>
                  <div className="col-12 col-md-3 d-flex justify-content-end">
                    <span className={cx(styles.blueContainerBtn)}>
                      <DamagedModal />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div ref={ref5} className={cx(styles.experience2)}>
            <div className={cx(styles.cxVline)}>
              <Image src={cxVline} alt="Line" />
            </div>
            <div className={cx(styles.cxVlineVl)}></div>

            <div className="d-block w-100">
              <h2>وضعیت رضایت مشتریان دیجی‌کالا از کیفیت کالاها</h2>
              <p>
                دیجی‌کالا میزان رضایت مشتریان از کیفیت کالاها را با کمک یک
                نظرسنجی اختصاصی می‌سنجد. این بررسی به ویژه پس از تبدیل شدن
                دیجی‌کالا به یک مارکت پلیس و حضور کالاهای دیگر فروشندگان در کنار
                دیجی‌کالا با تأکید بیشتری ادامه پیدا کرد.
              </p>
              <p>
                در این پرسشنامه که سه روز پس از هر خرید به مشتری ارسال می‌شود
                درباره کیفیت تمامی کالاهای خریداری شده در یک سفارش پرسیده
                می‌شود.
              </p>

              {/* PSAT VIDEO */}
              <div className={cx(styles.screenVideoContainer)}>
                <video
                  muted
                  loop
                  playsInline
                  controls={false}
                  autoPlay
                  className={cx(styles.iPhoneScreenVideo)}
                  src={cxPSAT}
                />
                <Image
                  src={iPhoneFrame}
                  alt="iPhone Frame"
                  width={260}
                  className={cx(styles.iPhoneFrame)}
                />
              </div>

              <div ref={refSat2} className={cx(styles.purpleContainer)}>
                <div className="d-inline-block">
                  <p>در ۹ ماه اول سال ۱۴۰۱</p>
                  <Image
                    className={cx(styles.inlineStars)}
                    src={cx4stars}
                    alt="Tweet about Quality"
                  />{" "}
                  <h3 style={{ display: "inline" }}> امتیاز ۴/۱ از ۵ </h3>
                  <motion.hr
                    style={{ scaleX: scrollRefSat2 }}
                    transition={spring}
                  />
                </div>

                <h6 className="pb-3">
                  میانگین امتیاز رضایت مشتریان نسبت به کیفیت کالاها
                </h6>
              </div>

              <Image
                src={cxAssortments}
                alt="Assortments chart"
                className={cx(styles.fullautoImage, "py-4 px-2")}
              />

              <div className={cx(styles.pinkContainer)}>
                <p>
                  بالا رفتن تنوع کالایی در سال‌های اخیر با ثبات رضایت از کیفیت
                  کالاها همراه بوده است.
                </p>
              </div>
            </div>
          </div>

          <div ref={ref6} className={cx(styles.experience2)}>
            <div className={cx(styles.cxVline)}>
              <Image src={cxVline} alt="Line" />
            </div>
            <div className={cx(styles.cxVlineVl)}></div>

            <div className="d-block w-100">
              <h2>برای خرید کالاهای با کیفیت بهتر به چه نکاتی توجه کنیم؟</h2>
              <p>
                ما در دیجی‌کالا می‌خواهیم مشاور قابل اعتماد برای خرید باشیم.
                برای دستیابی به این هدف مواردی را که در کنترل ماست با دقت بررسی
                می‌کنیم و از راهکارهای مختلف برای شفاف سازی فرایندها و رویه‌ها
                گام بر می‌داریم.
              </p>

              <div className={cx(styles.cxVlineCricle)}>
                <Image src={circle} alt="circle" />
              </div>
              <h5 className={cx(styles.innerHeadings)}>
                امتیاز عملکرد فروشندگان
              </h5>
              <p>
                امتیاز کیفیت هر کالای عرضه شده توسط هر فروشنده و نرخ مرجوعی هر
                فروشنده سرنخ مناسبی‌ست که می‌تواند به خرید کالاهای با کیفیت بهتر
                به شما کمک کند.
              </p>

              {/* VIDEO */}
              <div className={cx(styles.screenVideoContainer)}>
                <video
                  muted
                  loop
                  playsInline
                  controls={false}
                  autoPlay
                  className={cx(styles.iPhoneScreenVideo)}
                  src={cxReturn}
                />
                <Image
                  src={iPhoneFrame}
                  alt="iPhone Frame"
                  width={260}
                  className={cx(styles.iPhoneFrame)}
                />
              </div>

              <div className={cx(styles.cxVlineCricle)}>
                <Image src={circle} alt="circle" />
              </div>
              <h5 className={cx(styles.innerHeadings)}>امتیاز کیفیت هر کالا</h5>
              <p>
                تمامی کالاها بر اساس میزان پیشنهاد خریداران پس از ثبت دیدگاه و
                شرکت در نظرسنجی رضایت از کیفیت، دارای امتیاز 1 تا 5 هستند. توجه
                به این امتیاز کمک می‌کند تا در دسته بندی های مختلف محصولات،
                کالاهای با کیفیت تری خریداری کنید.
              </p>

              <div className={cx(styles.smsBox)}>
                <Image
                  src={psatTypes}
                  alt="PSAT types"
                  className={cx(styles.commentsSentimentImage)}
                />
              </div>

              <Image
                src={psatVerticals}
                alt="PSAT in Vrticals"
                className={cx(styles.fullautoImage, "py-4 px-2")}
              />

              <div className={cx(styles.pinkContainer)}>
                <p className="mb-3">
                  امتیاز رضایت از کالاها در گروه‌های کالایی مختلف، یکسان نیست.
                  انتظار می‌رود کالاهای دارای برند مشخص مانند موبایل یا محصولات
                  سوپرمارکتی نسبت به کالاهای دسته مد و پوشاک، امتیاز بالاتری از
                  نظر میزان رضایت از کیفیت داشته باشند، برای مثال مشاهده امتیاز
                  ۸۳ از ۱۰۰ برای گروه های کالایی زیر معنای مختلفی دارند:
                </p>
                <div className="row">
                  <div className="col-4 text-center">
                    <h4>مد و پوشاک</h4>
                    <h5>خیلی خوب</h5>
                  </div>
                  <div className={cx(styles.midColBorder, "col-4 text-center")}>
                    <h4>کالای دیجیتال</h4>
                    <h5>متوسط</h5>
                  </div>
                  <div className="col-4 text-center">
                    <h4>محصولات سوپرمارکتی</h4>
                    <h5>ضعیف</h5>
                  </div>
                </div>
              </div>

              <div className={cx(styles.cxVlineCricle)}>
                <Image src={circle} alt="circle" />
              </div>
              <h5 className={cx(styles.innerHeadings)}>محتواهای کاربران</h5>
              <p>
                قابلیت پرسش و پاسخ با فروشندگان و خواندن کامنت‌های دیگران فرصت
                مناسبی‌ست که پیش از خرید، درباره کالای مورد نظرتان وارد گفتگو با
                فروشنده همان کالا شوید. همچنین امکان ثبت دیدگاه، تولید محتوای
                تصویری و ویدیویی برای تمامی کالاها و مشاهده دیدگاه‌های دیگران
                وجود دارد. دیدگاه‌های کاربران، نقطه تماس مهمی برای دیجی‌کالاست
                تا از تجربه شما باخبر شویم.
              </p>

              <div className={cx(styles.greenContainer)}>
                <h4>
                  چطور می‌توانید به دیجی‌کالا در عرضه کالاهای با کیفیت کمک کنید؟
                </h4>
                <h6>انتخاب دقیق علت مرجوعی یک کالا</h6>
                <p>
                  مغایرت و غیر اصل بودن کالا دو مورد از دلایلی هستند که مشتریان
                  در زمان مرجوعی ممکن است به جای یکدیگر به کار ببرند. هنگامی که
                  تصمیم به بازگرداندن یک کالا بگیرید لازم است دلیل مرجوع کردن را
                  به درستی انتخاب کنید. تعدادی از گزینه‌های پیشنهادی به شما
                  مربوط به کیفیت کالاهاست. با انتخاب صحیح علت مرجوعی به
                  دیجی‌کالا کمک می‌کنید تا از بازخوردهای شما نسبت به کیفیت
                  کالاها مطلع شود.
                </p>

                <h6>شرکت در نظرسنجی رضایت از کیفیت کالاها</h6>
                <p>
                  به نظرسنجی‌هایی که تا سه روز پس از هر خرید برایتان ارسال
                  می‌شود و از شما در مورد هر کدام از کالاهای خریداری شده می‌پرسد
                  دقت کنید. هرچه مشارکت شما در این نظرسنجی بیشتر باشد آگاهی
                  دیجی‌کالا نسبت به وضعیت رضایت شما از کیفیت کالاهایی که اجازه
                  فروش در مارکت پلیس دارند هم بیشتر می‌شود.
                </p>

                <h6>گزارش نادرستی مشخصات</h6>
                <p>
                  از امکان بازخوردن دادن درباره کالاها در تمامی صفحات محصول
                  استفاده کنید.
                </p>
              </div>
            </div>
          </div>

          <div ref={ref7} className={cx(styles.experienceShare)}>
            <div className={cx(styles.share)}>
              <div className="d-block">
                <h6 className={cx(styles.shareTitle)}>به اشتراک بگذارید</h6>
              </div>
              <div className="d-block">
                <span
                  onClick={onShareHandler}
                  className={cx(styles.copyLink, "me-3")}
                >
                  <Image src={linkShare} alt="Link Share" />
                </span>
                <a
                  className="me-3"
                  target="_blank"
                  rel="noreferrer"
                  href={`mailto:?subject=${pageDetails.pageTitle}
                                &${pageDetails.pagePath}
                                &body=سلام %0A این صفحه از سایت درباره دیجی‌کالا رو ببین.%0A سپاس
                                `}
                >
                  <Image src={emailShare} alt="Email Share" />
                </a>
                <a
                  className="me-3"
                  rel="noreferrer"
                  target="_blank"
                  href={`https://t.me/share/url?url=${pageDetails.pagePath}} 
                    &text=${encodeURIComponent(pageDetails.pageTitle)}`}
                >
                  <Image src={telegramShare} alt="Telegram Share" />
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={`whatsapp://send?text=${encodeURIComponent(
                    pageDetails.pagePath
                  )}`}
                  data-action="share/whatsapp/share"
                >
                  <Image src={whatsappShare} alt="Whatsapp Share" />
                </a>
              </div>
            </div>

            <div className={cx(styles.comment)}>
              <div className="d-block">
                <h6 className={cx(styles.shareTitle)}>
                  آیا این مطلب برایتان مفید بود؟
                </h6>
              </div>
              <div className="d-block">
                <span className="me-3">
                  <Image
                    src={dislike}
                    alt="Dislike"
                    style={{ cursor: "pointer" }}
                  />
                </span>
                <span>
                  <Image src={like} alt="Like" style={{ cursor: "pointer" }} />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Index;
